import React, { useState, useEffect } from 'react';
import Role from './Role';
import { Wrapper } from './Roles.styles';

const Roles = ({ roles, isMaxRolesCountReached, permissions }) => {
  const [localRoles, setLocalRoles] = useState([]);
  const [isDuplicateInProgress, setIsDuplicateInProgess] = useState(false);

  useEffect(() => {
    setLocalRoles(roles);
  }, [roles]);

  const onDuplicate = id => {
    // while duplicate is in progress role is kept in local state and it is added on submit
    const roleDefinition = roles.find(x => x.id === id);

    const roleToDuplicate = {
      ...roleDefinition,
      name: roleDefinition.name + ' Copy',
      isBeingDuplicated: true, //NOTE: on Submit we don't use the entire object, so adding another property
      // doesn't bring BE errors but gives a flag to check against
    };
    setLocalRoles(prevArray => [...prevArray, roleToDuplicate]);
    setIsDuplicateInProgess(true);
  };
  const handleDuplicateComplete = () => {
    setIsDuplicateInProgess(false);
  };
  return (
    <Wrapper>
      {localRoles.map(role => {
        return (
          <Role
            role={role}
            key={role.name}
            onDuplicate={onDuplicate}
            isDuplicateInProgress={isDuplicateInProgress}
            duplicateComplete={handleDuplicateComplete}
            isMaxRolesCountReached={isMaxRolesCountReached}
            permissions={permissions}
          />
        );
      })}
    </Wrapper>
  );
};

export default Roles;
